import { render, staticRenderFns } from "./DraftTicketOverview.vue?vue&type=template&id=7263523a"
import script from "./DraftTicketOverview.vue?vue&type=script&lang=js"
export * from "./DraftTicketOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports